var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _c(
        "Grid",
        {
          staticClass: "installments",
          attrs: { columns: _vm.columns, items: _vm.items || [] },
          scopedSlots: _vm._u([
            {
              key: "datePicker",
              fn: function({ props: { dataItem } }) {
                return [
                  _c(
                    "td",
                    [
                      _c("UIDatePicker", {
                        attrs: {
                          clearable: false,
                          value: dataItem.date,
                          disabled: dataItem.paid,
                          "allowed-dates": { maxDate: _vm.today }
                        },
                        on: {
                          input: e =>
                            _vm.updateRow(
                              dataItem.row,
                              Object.assign({}, dataItem, { date: e })
                            )
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "amount",
              fn: function({ props: { dataItem } }) {
                return [
                  _c(
                    "td",
                    [
                      _c("NumberInput", {
                        attrs: {
                          value: dataItem.amount,
                          disabled: dataItem.paid
                        },
                        on: {
                          input: e =>
                            _vm.updateRow(
                              dataItem.row,
                              Object.assign({}, dataItem, { amount: e })
                            )
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "charged",
              fn: function({ props: { dataItem } }) {
                return [
                  _c(
                    "td",
                    [
                      dataItem.paid
                        ? _c("IconS", {
                            staticClass: "check-icn",
                            attrs: { name: "check-circle" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "removeRow",
              fn: function({ props: { dataItem } }) {
                return [
                  _c(
                    "td",
                    {
                      staticClass: "text-right",
                      staticStyle: { width: "50px" }
                    },
                    [
                      !dataItem.paid
                        ? _c(
                            "span",
                            {
                              staticClass: "remove",
                              on: {
                                click: function($event) {
                                  return _vm.removeRow(dataItem.row)
                                }
                              }
                            },
                            [_c("Icon", { attrs: { name: "trash" } })],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "noRecords" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "center" } },
              [
                _c(
                  "span",
                  { staticClass: "add-payment", on: { click: _vm.addPayment } },
                  [_vm._v("Click here to add the first Payment")]
                )
              ]
            )
          ])
        ],
        2
      ),
      _vm.distributionType == "Custom" && _vm.items.length > 0
        ? _c(
            "Box",
            { staticClass: "add-additional" },
            [
              _c("Icon", {
                staticClass: "icon",
                attrs: { name: "plus-circle" }
              }),
              _c(
                "span",
                { staticClass: "add-payment", on: { click: _vm.addPayment } },
                [_vm._v("Add an additional installment")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }